export const authConstants = {
  SIGN_IN: 'SING_IN',
  SIGN_OUT: 'SING_OUT',
  OPEN_LOG_IN_AND_SIGN_UP_DIALOG: 'OPEN_LOG_IN_AND_SIGN_UP_DIALOG',
  CLOSE_LOG_IN_AND_SIGN_UP_DIALOG: 'CLOSE_LOG_IN_AND_SIGN_UP_DIALOG',
  OPEN_FORCE_AUTH_DIALOG: 'OPEN_FORCE_AUTH_DIALOG',
  CLOSE_FORCE_AUTH_DIALOG: 'CLOSE_FORCE_AUTH_DIALOG',
};
